import { IconContent } from '@icons';

export const arrowCounterclockwise: IconContent = {
    sm: '<path d="M7 12.5A5.5 5.5 0 1 1 12.5 7h1A6.5 6.5 0 1 0 7 13.5h3v-1H7Z" /><path d="M6.5 4.5h1V7H10v1H6.5V4.5ZM11.159 13l-1.78-2.075-.759.65L9.841 13l-1.22 1.425.759.65L11.158 13Z" />',
    md: '<path d="M9 1a8 8 0 1 0 0 16h4.5v1H9a9 9 0 1 1 9-9h-1a8 8 0 0 0-8-8Z" /><path d="m14.29 17.5-2.854-2.854-.707.707 2.146 2.147-2.146 2.146.707.707 2.853-2.853ZM8.5 4h1v4.643h3.786v1H8.5V4Z" />',
};
